import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/router'
import './assets/index.scss'
import {
	post
} from '@/utils/request.js';
import "amfe-flexible/index.js";
import VueScroller from 'vue-scroller'
import VueAMap from 'vue-amap';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.use(VueScroller)
Vue.use(VueAMap);
Vue.config.productionTip = false;
Vue.prototype.$http = {
	POST: post
};
VueAMap.initAMapApiLoader({
	key: '2d12bd954081891fb94aaa0103042115',
	plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar',
		'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'AMap.CitySearch',
		'AMap.Geocoder', 'AMap.Driving'
	],
	// 默认高德 sdk 版本为 1.4.4
	v: '1.4.4'
});
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
